module.exports = __webpack_public_path__ + "img/L1.1f32b5e6.png";